import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { LoginModal, LogoutModal } from '../models/Login';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { RestApi } from '../shared/apiUrls';
import { catchError } from 'rxjs/operators';
import { PromiseResult } from '../models/PromiseResult';
import { Router } from '@angular/router';
import { OTP_Validate } from '../models/util.models';
import { PhoneNumberExists } from '../models/User'; import { ProviderStateService } from './provider-state.service';


@Injectable({
    providedIn: 'root'
})
export class AuthService {
    //private handleError: HandleError;
    slug: string = "";
    constructor(
        private readonly http: HttpClient,
        private readonly router: Router,
        private readonly providerstateService: ProviderStateService
    ) {
        this.slug = this.providerstateService.getProviderSlug();
    }

    private handleError(error: HttpErrorResponse) {
        return throwError(error);
    }

    private data = new BehaviorSubject(-1);
    data$ = this.data.asObservable();

    changeData(data: number) {
        this.data.next(data);
    }

    loginUser(loginuser: LoginModal): Observable<PromiseResult> {
        return this.http
            .post<PromiseResult>(
                RestApi.Urls.AuthApi + 'login/mobile',
                loginuser
            )
            .pipe(catchError(this.handleError));
    }

    loginDoctor(logindoctor: LoginModal): Observable<PromiseResult> {
        return this.http
            .post<PromiseResult>(
                RestApi.Urls.AuthApi + 'Doctor/Login/Mobile',
                logindoctor
            )
            .pipe(catchError(this.handleError));
    }

    logoutUser(logoutUser: LogoutModal): Observable<PromiseResult> {
        return this.http
            .post<PromiseResult>(
                RestApi.Urls.AuthApi + 'Logout/mobile',
                logoutUser
            )
            .pipe(catchError(this.handleError));
    }
    refresh(): Observable<any> {
        const user_guid = sessionStorage.getItem('userid');
        const refreshToken = sessionStorage.getItem('refresh_token');
        if (user_guid == null || refreshToken == null) {
            this.router.navigate(['/' + this.slug + '/accessdenied']);
            return;
        }
        return this.http.post(RestApi.Urls.AuthApi + 'Login/refresh', {
            user_guid,
            refreshToken
        });
    }
    refreshDoctor(): Observable<any> {
        const user_guid = sessionStorage.getItem('userid');
        const refreshToken = sessionStorage.getItem('refresh_token');
        if (user_guid == null || refreshToken == null) {
            this.router.navigate(['/' + this.slug + '/accessdenied']);
            return;
        }
        return this.http.post(RestApi.Urls.AuthApi + 'Doctor/Login/refresh', {
            user_guid,
            refreshToken
        });
    }

    getRole(): Observable<PromiseResult> {
        return this.http.get<PromiseResult>(RestApi.Urls.AuthApi + "fetch/role").pipe(catchError(this.handleError))
    }

    login_validate_or_resend_otp_patient(data: OTP_Validate) {
        return this.http
            .post<PromiseResult>(
                RestApi.Urls.AuthApi +
                'login/otp/validate',
                data
            )
            .pipe(catchError(this.handleError));
    }

    login_validate_or_resend_otp_doctor(data: OTP_Validate) {
        return this.http
            .post<PromiseResult>(
                RestApi.Urls.AuthApi +
                'doctor/login/otp/validate',
                data
            )
            .pipe(catchError(this.handleError));
    }

    phone_exists(data: PhoneNumberExists): Observable<PromiseResult> {
        return this.http.post<PromiseResult>(
            RestApi.Urls.AuthApi +
            "phone/exists", data
        ).pipe(catchError(this.handleError));
    }
}
